<template>
  <div>


    <b-card>

      <div>

        <h4 class="text-primary text-center mb-1">PRE ANESTESICO</h4>

        <div class="mb-1" v-if="dataProceso">
          <b>Procedimiento:</b> {{ dataProceso.codigo }} - {{ dataProceso.descripcion }}
          <b>Paciente: </b> {{ dataProceso.paciente }}
        </div>

        <b-tabs pills nav-wrapper-class="w-15" vertical active-nav-item-class="font-weight-bold text-uppercase"
          active-tab-class="font-weight-bold text-primary">

          <b-tab title="Valoracion - Antecedentes">
            <span>
                  Procedimientos Propuestos:
                </span>
              
                
            <b-row class="mb-3">
              
              <b-col cols="9">
                
                 <SearchOpts
                  v-model="procedimientoSelected"
                  :searchService="procedimientosService.searchByQuery"
                  :placeholder="'Ingrese el nombre del procedimiento...'"                 
                  class="form-control-sm"
                />
              </b-col>
              <b-col>
                <b-button size="sm" variant="warning" @click="agregarProcedimiento">
                  <i class="fa-plus fa-1x fa-solid"></i>
                </b-button>
              </b-col>
             
            </b-row>
            <b-row class="mb-1">
               <b-col>
                <b-table small v-if="preanestesico.procedimientosList.length" :fields="fieldsProcedimientos" :items="preanestesico.procedimientosList">
                          <template #cell(acciones)="data">
                      <b-button @click="eliminarProcedimiento(data.index)" variant="danger" size="sm">
                        <i class="fa-solid fa-trash"></i>
                      </b-button>
                    </template>
                </b-table>
                <b-alert show v-else variant="warning">
                  <div class="p-2 text-center">
                    <span>No existen procedimientos registrados.</span>
                  </div>

                </b-alert>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <span>Tipo:</span>
                <b-form-radio-group class="my-1" v-model="preanestesico.tipoProcedimiento" :options="[
                  { text: 'Electiva', value: 'electiva' },
                  { text: 'Emergencia', value: 'emergencia' },
                  { text: 'Urgencia', value: 'urgencia' }
                ]"></b-form-radio-group>
              </b-col>
              <b-col>
                <span>Riesgo Quirurgico:</span>
                <b-form-radio-group class="my-1" v-model="preanestesico.riesgoQuirurgico" :options="[
                  { text: 'Bajo', value: 'bajo' },
                  { text: 'Moderado', value: 'moderado' },
                  { text: 'Alto', value: 'alto' }
                ]"></b-form-radio-group>
              </b-col>

            </b-row>
            <hr />
            <b-row class="mb-2">
              <b-col>
                <span>Antecedentes Patologicos Personales</span>
                <b-form-textarea v-model="preanestesico.antecedentesPersonales"></b-form-textarea>

                
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <span>Antecedentes anestésicos:</span>
                <b-form-textarea v-model="preanestesico.antecedentesAnestesicos"></b-form-textarea>
              </b-col>
              <b-col>
                <span>Antecedentes quirurgicos:</span>
                <b-form-textarea v-model="preanestesico.antecedentesQuirurgicos"></b-form-textarea>
              </b-col>
              <b-col>
                <span>Antecedentes alergicos:</span>
                <b-form-textarea v-model="preanestesico.antecedentesAlergicos"></b-form-textarea>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <span>Antecedentes transfusiones:</span>
                <b-form-textarea v-model="preanestesico.antecedentesTransfusiones"></b-form-textarea>
              </b-col>
              <b-col>
                <span>Antecedentes habitos:</span>
                <b-form-textarea v-model="preanestesico.antecedentesHabitos"></b-form-textarea>
              </b-col>
              <b-col>
                <span>Antecedentes Familiares:</span>
                <b-form-textarea v-model="preanestesico.antecedentesFamiliares"></b-form-textarea>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab title="Examen Fisico">
            <span class="mt-1 ">
              Constantes Vitales/Antropometria:
            </span>
            <b-row>
              <b-col>

                <b-alert variant="success" v-if="preanestesico.constantesVitales" show>

                  <div class="row mt-1 p-1">
                    <div class="col-4">
                      <label class="text-dark text-center">Tension Arterial: <span> {{
                        preanestesico.constantesVitales.tensionArterial }}</span> </label>

                    </div>
                    <div class="col-4">
                      <label class="text-dark text-center">Frecuencia Cardiaca: <span> {{
                        preanestesico.constantesVitales.frecuenciaCardiaca }}</span> </label>

                    </div>
                    <div class="col-4">
                      <label class="text-dark text-center">Frecuencia Respiratoria: <span> {{
                        preanestesico.constantesVitales.frecuenciaRespiratoria }} </span> </label>

                    </div>
                  </div>
                  <div class="row mt-1 p-1">
                    <div class="col-4">
                      <label class="text-dark text-center">Temperatura: <span>{{
                        preanestesico.constantesVitales.temperatura }}</span> °</label>

                    </div>
                    <div class="col-4">
                      <label class="text-dark text-center">Sat Oxigeno: <span>{{
                        preanestesico.constantesVitales.saturacionOxigeno }}</span></label>

                    </div>
                    <div class="col-4">
                      <label class="text-dark text-center">Talla (cm): <span>{{ preanestesico.constantesVitales.talla
                          }}</span> </label>

                    </div>
                  </div>
                  <div class="row mt-1 p-1">
                    <div class="col-4">
                      <label class="text-dark text-center">Peso (kg): <span> {{ preanestesico.constantesVitales.peso
                          }}</span> </label>

                    </div>
                    <div class="col-4">
                      <label class="text-dark text-center">Imc (kg/m2): <span> {{ preanestesico.constantesVitales.imc
                          }}</span> </label>

                    </div>
                    <div class="col-4">
                      <label class="text-dark text-center">Glascow:</label> <b-form-input
                        placeholder="Ingrese indice glascow" v-model="preanestesico.glascow"></b-form-input>

                    </div>
                  </div>
                </b-alert>
                <b-alert variant="warning" v-else show>
                  <div class="text-center p-4">
                    <i class="fa-solid fa-2x fa-heart-pulse"></i>
                    <span>No existen signos registrados.</span>

                  </div>
                </b-alert>
              </b-col>
            </b-row>
          
            <span>Via Aerea</span>
            <b-row class="p-1">
              <b-col>
                <div class="row">
                  <div class="col">
                    <label class="text-dark">Apertura Bucal (cm)</label>
                    <b-form-radio-group id="radio-group-apBucal" v-model="preanestesico.viaAerea.aperturaBucal"
                      :options="optionsABucal"></b-form-radio-group>

                  </div>
                  <div class="col">
                    <label class="text-dark">Distancia Tiromentoneana (cm)</label>
                    <b-form-radio-group id="radio-group-dtiro" v-model="preanestesico.viaAerea.distanciaTiromentoneana"
                      :options="optionsDistanciaTiromentoneana"></b-form-radio-group>

                  </div>
                  <div class="col">
                    <label class="text-dark">Mallampati</label>
                    <b-form-radio-group id="radio-group-mallampati" v-model="preanestesico.viaAerea.mallampati"
                      :options="['I', 'II', 'III', 'IV']"></b-form-radio-group>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row class="p-1">
              <b-col>
                <div class="row">
                  <div class="col">
                    <label class="text-dark">Protrusion Mandibular</label>
                    <b-form-radio-group id="radio-group-protusion" v-model="preanestesico.viaAerea.protrusionMandibular"
                      :options="[{value:'1', text:'<0'}, {value:'2', text:'0'}, {value:'3', text:'>0'}]"></b-form-radio-group>

                  </div>
                  <div class="col">
                    <label class="text-dark">Perimetro Cervical (cm)</label>
                    <b-form-radio-group id="radio-group-pcervical" v-model="preanestesico.viaAerea.perimetroCervical"
                      :options="[{value:'1', text:'<40'}, {value:'2', text:'>40'}]"></b-form-radio-group>

                  </div>
                  <div class="col">
                    <label class="text-dark">Movilidad Cervical</label>
                    <b-form-radio-group id="radio-group-mcervical" v-model="preanestesico.viaAerea.movilidadCervical"
                      :options="[{value:'1', text:'<35'}, {value:'2', text:'>35'}]"></b-form-radio-group>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row class="p-1">
              <b-col>
                <div class="row">
                  <div class="col">
                    <label class="text-dark">Historia Intubacion Dificil</label>
                    <b-form-radio-group id="radio-group-historiaIntubacion"
                      v-model="preanestesico.viaAerea.historiaIntubacion" :options="['SI', 'NO']"></b-form-radio-group>

                  </div>
                  <div class="col">
                    <label class="text-dark">Patologia Asociada Intubacion</label>
                    <b-form-radio-group id="radio-group-pintubacion"
                      v-model="preanestesico.viaAerea.patologiaIntubacion" :options="['SI', 'NO']"></b-form-radio-group>

                  </div>
                  <div class="col">
                    <label class="text-dark">Otros:</label>
                    <b-form-input placeholder="Describa otros.." v-model="preanestesico.viaAerea.otros"></b-form-input>
                  </div>
                </div>
              </b-col>
            </b-row>

            <span>Examen fisico</span>
            <b-row class="p-1">
              <b-col>
                <div class="row">
                  <div class="col">
                    <label class="text-dark">Torax</label>
                    <b-form-textarea v-model="preanestesico.torax"></b-form-textarea>
                  </div>
                  <div class="col">
                    <label class="text-dark">Corazón</label>
                    <b-form-textarea v-model="preanestesico.corazon"></b-form-textarea>
                  </div>
                  <div class="col">
                    <label class="text-dark">Pulmones</label>
                    <b-form-textarea v-model="preanestesico.pulmones"></b-form-textarea>
                  </div>

                </div>
                <div class="row">
                  <div class="col">
                    <label class="text-dark">Abdomen</label>
                    <b-form-textarea v-model="preanestesico.abdomen"></b-form-textarea>
                  </div>
                  <div class="col">
                    <label class="text-dark">Extremidades</label>
                    <b-form-textarea v-model="preanestesico.extremidades"></b-form-textarea>
                  </div>
                  <div class="col">
                    <label class="text-dark">Sistema Nervioso Central</label>
                    <b-form-textarea v-model="preanestesico.sistemaNervioso"></b-form-textarea>
                  </div>

                </div>
                <div class="row">
                  <div class="col">
                    <label class="text-dark">Equivalente metabólico (METS)</label>
                    <b-form-textarea v-model="preanestesico.equivalenteMetabolico"></b-form-textarea>
                  </div>


                </div>
              </b-col>
            </b-row>

          </b-tab>
          <b-tab title="Resultados Examenes">
            <div class="p-1">
              <span>Examenes Laboratorio:</span>
              <div class="row mt-1">
                <label>
                  Hemograma:
                </label>
              </div>
              <b-row>
                <b-col>
                  <label>HCTO</label>
                  <b-form-input v-model="preanestesico.laboratorio.hemograma.hcto"></b-form-input>
                </b-col>
                <b-col>
                  <label>HB</label>
                  <b-form-input v-model="preanestesico.laboratorio.hemograma.hb"></b-form-input>
                </b-col>
                <b-col>
                  <label>PLAQUETAS</label>
                  <b-form-input v-model="preanestesico.laboratorio.hemograma.plaquetas"></b-form-input>
                </b-col>
                <b-col>
                  <label>TP</label>
                  <b-form-input v-model="preanestesico.laboratorio.hemograma.tp"></b-form-input>
                </b-col>
                <b-col>
                  <label>TTP</label>
                  <b-form-input v-model="preanestesico.laboratorio.hemograma.ttp"></b-form-input>
                </b-col>
                <b-col>
                  <label>INR</label>
                  <b-form-input v-model="preanestesico.laboratorio.hemograma.inr"></b-form-input>
                </b-col>
                <b-col>
                  <label>LEUCOCITOS</label>
                  <b-form-input v-model="preanestesico.laboratorio.hemograma.leucocitos"></b-form-input>
                </b-col>
              </b-row>
              <div class="row mt-1">
                <label>
                  Tipificacion:
                </label>
              </div>
              <b-row>
                <b-col>
                  <label>GRUPO</label>
                  <b-form-input v-model="preanestesico.laboratorio.tipificacion.grupo"></b-form-input>
                </b-col>
                <b-col>
                  <label>FACTOR</label>
                  <b-form-input v-model="preanestesico.laboratorio.tipificacion.factor"></b-form-input>
                </b-col>


              </b-row>
              <div class="row mt-1">
                <label>
                  Quimica Sanguinea:
                </label>
              </div>
              <b-row>
                <b-col>
                  <label>GLUCOSA</label>
                  <b-form-input v-model="preanestesico.laboratorio.quimica.glucosa"></b-form-input>
                </b-col>
                <b-col>
                  <label>UREA</label>
                  <b-form-input v-model="preanestesico.laboratorio.quimica.urea"></b-form-input>
                </b-col>
                <b-col>
                  <label>CREATININA</label>
                  <b-form-input v-model="preanestesico.laboratorio.quimica.creatinina"></b-form-input>
                </b-col>
                <b-col>
                  <label>OTROS:</label>
                  <b-form-input v-model="preanestesico.laboratorio.quimica.otros"></b-form-input>
                </b-col>


              </b-row>
              <div class="row mt-1">
                <label>
                  Perfil Hepático:
                </label>
              </div>
              <b-row>
                <b-col>
                  <label>AST</label>
                  <b-form-input v-model="preanestesico.laboratorio.hepatico.ast"></b-form-input>
                </b-col>
                <b-col>
                  <label>ALT</label>
                  <b-form-input v-model="preanestesico.laboratorio.hepatico.alt"></b-form-input>
                </b-col>
                <b-col>
                  <label>FA</label>
                  <b-form-input v-model="preanestesico.laboratorio.hepatico.fa"></b-form-input>
                </b-col>
                <b-col>
                  <label>LDH</label>
                  <b-form-input v-model="preanestesico.laboratorio.hepatico.ldh"></b-form-input>
                </b-col>
                <b-col>
                  <label>BT</label>
                  <b-form-input v-model="preanestesico.laboratorio.hepatico.bt"></b-form-input>
                </b-col>
                <b-col>
                  <label>BD</label>
                  <b-form-input v-model="preanestesico.laboratorio.hepatico.bd"></b-form-input>
                </b-col>
                <b-col>
                  <label>BI</label>
                  <b-form-input v-model="preanestesico.laboratorio.hepatico.bi"></b-form-input>
                </b-col>


              </b-row>
              <div class="row mt-1">
                <label>
                  Ionograma:
                </label>
              </div>
              <b-row>
                <b-col>
                  <label>Na</label>
                  <b-form-input v-model="preanestesico.laboratorio.ionograma.na"></b-form-input>
                </b-col>
                <b-col>
                  <label>K</label>
                  <b-form-input v-model="preanestesico.laboratorio.ionograma.k"></b-form-input>
                </b-col>
                <b-col>
                  <label>CI</label>
                  <b-form-input v-model="preanestesico.laboratorio.ionograma.ci"></b-form-input>
                </b-col>
                <b-col>
                  <label>Ca</label>
                  <b-form-input v-model="preanestesico.laboratorio.ionograma.ca"></b-form-input>
                </b-col>
                <b-col>
                  <label>Mg</label>
                  <b-form-input v-model="preanestesico.laboratorio.ionograma.mg"></b-form-input>
                </b-col>

              </b-row>

              <div class="row mt-1">
                <label>
                  Orina:
                </label>
              </div>
              <b-row>
                <b-col>
                  <label>PH</label>
                  <b-form-input v-model="preanestesico.laboratorio.orina.ph"></b-form-input>
                </b-col>
                <b-col>
                  <label>DENSIDAD</label>
                  <b-form-input v-model="preanestesico.laboratorio.orina.densidad"></b-form-input>
                </b-col>
                <b-col>
                  <label>BACTERIAS</label>
                  <b-form-input v-model="preanestesico.laboratorio.orina.bacterias"></b-form-input>
                </b-col>
                 <b-col>
                  <label>LEUCOCITOS</label>
                  <b-form-input v-model="preanestesico.laboratorio.orina.leucocitos"></b-form-input>
                </b-col>
                <b-col>
                  <label>PIOCITOS</label>
                  <b-form-input v-model="preanestesico.laboratorio.orina.piocitos"></b-form-input>
                </b-col>
                <b-col>
                  <label>HEMATIES</label>
                  <b-form-input v-model="preanestesico.laboratorio.orina.hematies"></b-form-input>
                </b-col>
                <b-col>
                  <label>GLUCOSA</label>
                  <b-form-input v-model="preanestesico.laboratorio.orina.glucosa"></b-form-input>
                </b-col>


              </b-row>

              <div class="row mt-1">
                <label>
                  Gasometria:
                </label>
              </div>
              <b-row>
                <b-col>
                  <label>PH</label>
                  <b-form-input v-model="preanestesico.laboratorio.gasometria.ph"></b-form-input>
                </b-col>
                <b-col>
                  <label>Po2</label>
                  <b-form-input v-model="preanestesico.laboratorio.gasometria.po2"></b-form-input>
                </b-col>
                <b-col>
                  <label>PCo2</label>
                  <b-form-input v-model="preanestesico.laboratorio.gasometria.pco2"></b-form-input>
                </b-col>
                <b-col>
                  <label>HCo3</label>
                  <b-form-input v-model="preanestesico.laboratorio.gasometria.hco3"></b-form-input>
                </b-col>
                <b-col>
                  <label>Eb</label>
                  <b-form-input v-model="preanestesico.laboratorio.gasometria.eb"></b-form-input>
                </b-col>
                <b-col>
                  <label>SAT</label>
                  <b-form-input v-model="preanestesico.laboratorio.gasometria.sat"></b-form-input>
                </b-col>
                <b-col>
                  <label>LACTATO</label>
                  <b-form-input v-model="preanestesico.laboratorio.gasometria.lactato"></b-form-input>
                </b-col>

              </b-row>
              <div class="row mt-1">
                <label>
                  Hormonas:
                </label>
              </div>
              <b-row class="mb-1">
                <b-col>
                  <label>T4</label>
                  <b-form-input v-model="preanestesico.laboratorio.hormonas.t4"></b-form-input>
                </b-col>
                <b-col>
                  <label>TSH</label>
                  <b-form-input v-model="preanestesico.laboratorio.hormonas.tsh"></b-form-input>
                </b-col>


              </b-row>
              <span>Otros Exámenes: </span>
              <b-row>
                <b-col>
                  <label>EKG</label>
                  <b-form-textarea v-model="preanestesico.ekg"></b-form-textarea>

                </b-col>
                <b-col>
                  <label>RX TORAX</label>
                  <b-form-textarea v-model="preanestesico.rxTorax"></b-form-textarea>

                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <label>ESPIROMETRIA</label>
                  <b-form-textarea v-model="preanestesico.espirometria"></b-form-textarea>

                </b-col>
                <b-col>
                  <label>OTROS</label>
                  <b-form-textarea v-model="preanestesico.otros"></b-form-textarea>

                </b-col>
              </b-row>
            </div>
          </b-tab>
          <b-tab title="Escalas - Ingestas - Indicaciones">
            <span>Escalas e Indices</span>
            <b-row class="mb-1">

              <div class="col-4">
                <label class="text-dark">Riesgo Cardiaco</label>
                <b-form-textarea v-model="preanestesico.escalas.riesgoCardiaco"></b-form-textarea>

              </div>
              <div class="col-4">
                <label class="text-dark">Riesgo Pulmonar</label>
                <b-form-textarea v-model="preanestesico.escalas.riesgoPulmonar"></b-form-textarea>

              </div>
              <div class="col-4">
                <label class="text-dark">Estado Fisico ASA</label>
                <b-form-radio-group id="radio-group-estadoAsa" v-model="preanestesico.escalas.riesgos"
                  :options="['I', 'II', 'III', 'IV', 'V', 'VI']"></b-form-radio-group>

              </div>
              <div class="col-4">
                <label class="text-dark">Riesgo Tromboembólico</label>
                <b-form-textarea v-model="preanestesico.escalas.riesgoTrombo"></b-form-textarea>

              </div>
              <div class="col">
                <label class="text-dark">Otros:</label>
                <b-form-textarea v-model="preanestesico.escalas.otros"></b-form-textarea>

              </div>

            </b-row>
            <span>Tiempo Ultima Ingesta</span>
            <b-row class="mb-1">

              <div class="col-4">
                <label class="text-dark">Liquidos Claros</label>
                <b-form-textarea v-model="preanestesico.ultimaIngesta.liquidosClaros"></b-form-textarea>

              </div>
              <div class="col-4">
                <label class="text-dark">Leche de Formula</label>
                <b-form-textarea v-model="preanestesico.ultimaIngesta.lecheFormula"></b-form-textarea>

              </div>
              <div class="col-4">
                <label class="text-dark">Leche Materna</label>
                <b-form-textarea v-model="preanestesico.ultimaIngesta.lecheMaterna"></b-form-textarea>

              </div>
              <div class="col-4">
                <label class="text-dark">Solidos</label>
                <b-form-textarea v-model="preanestesico.ultimaIngesta.solidos"></b-form-textarea>

              </div>



            </b-row>
            <span> Indicaciones</span>
            <b-row class="mb-1">

              <div class="col">

                <b-form-textarea v-model="preanestesico.indicaciones"></b-form-textarea>

              </div>
            </b-row>
            <span>Plan Anéstesico</span>
            <b-row class="mb-1">

              <div class="col">

                <b-form-textarea v-model="preanestesico.planAnestesico"></b-form-textarea>

              </div>
            </b-row>
            <span>Observaciones</span>
            <b-row class="mb-1">

              <div class="col">

                <b-form-textarea v-model="preanestesico.observaciones"></b-form-textarea>

              </div>
            </b-row>
          </b-tab>
          <b-tab title="Diagnosticos - Medico Responsable">
            <b-card>
              <span>
                Diagnosticos:
              </span>
              
              <b-row>
                <b-col cols="9">
                  <SearchOpts v-model="searchDiagnostico" :searchService="diagnosticosService.getByQuerySelect"
                    :minChars="3" :placeholder="'Buscar diagnostico...'" class="form-control-sm" />
                </b-col>
                <b-col>
                  <b-button size="sm" @click="agregarDiagnostico" variant="warning"> <b><i
                        class="fa-solid fa-1x fa-plus"></i></b></b-button>
                </b-col>
              </b-row>
              <b-row class="my-2">
                <b-col v-if="preanestesico.diagnosticosList.length && preanestesico.diagnosticosList.length > 0">

                  <b-table small :fields="fields" :items="preanestesico.diagnosticosList">

                    <template #cell(acciones)="data">
                      <b-button variant="danger" size="sm" @click="eliminarRegistro(data.index)">
                        <font-awesome-icon icon="circle-xmark" />
                      </b-button>
                    </template>
                  </b-table>
                </b-col>
                <b-col v-else>
                   <b-alert variant="warning" show>
                    <div class="text-center p-2">
                      <span>Sin diagnosticos.</span>
                    </div>
                </b-alert>
                </b-col>
               
              </b-row>
              <hr />
              <span>Datos del profesional responsable:</span>
              
              <b-row class="mt-1">

                <b-col class="col-10">
                  <span>Medico Responsable:</span>
                  <SearchOpts v-model="doctor" :searchService="searchAnestesiologo"
                    :placeholder="'Buscar medico por nombre'" />
                </b-col>
                <b-col class="col-2 mt-2">
                  <b-button title="Agregar medico" @click="agregarMedico" variant="success" size="sm">
                    <i class="fa-solid fa-plus"></i>
                  </b-button>
                </b-col>

                <b-col v-if="preanestesico.medicoResponsable" class="mt-1" cols="12">

                  <b-table v-if="preanestesico.medicoResponsable.length" small :items="preanestesico.medicoResponsable"
                    :fields="fieldsMedicos">

                    <template #cell(acciones)="data">
                      <b-button @click="eliminarMedicoResponsable(data.index)" variant="danger" size="sm">
                        <i class="fa-solid fa-trash"></i>
                      </b-button>
                    </template>
                  </b-table>
                </b-col>


              </b-row>

            </b-card>
          </b-tab>


        </b-tabs>
      </div>

      <div class="text-right mt-4 p-2" >
        <b-button variant="primary" class="mr-2" @click="onSavePreAnestesico">
          Guardar
        </b-button>

       
      </div>
    </b-card>

  </div>

</template>

<script>
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { SearchOpts } from "@/shared/components";
import { doctoresService, auxiliarService } from "@/shared/services";
import { diagnosticosService } from "../../../atencionMedica/services";
import { procedimientosFormulariosService, procedimientosService } from "../../services";
import { personasService } from '../../../admision/services';
import vSelect from "vue-select";





export default {
  components: {
    flatPickr,
    SearchOpts,

    VueTimepicker,
    vSelect
  },

  data() {
    return {
      optionsDistanciaTiromentoneana: [{ value: '1', text: "<6" }, { value: '2', text: "6 - 6,5" }, { value: '3', text: ">6,5" }],
      optionsABucal: [{ value: '1', text: "<2" }, { value: '2', text: "2 - 2,5" }, { value: '3', text: "2,6 - 3" }, { value: '4', text: ">3" }],

      glascow: null,
      selectedProfesional: null,
      selectedDoctor: null,
      optionsTipoIntegrante: [
        { value: 'Cirujano1', text: 'Cirujano1' },
        { value: 'Cirujano2', text: 'Cirujano2' },
        { value: 'Instrumentista', text: 'Instrumentista' },
        { value: 'Circulante', text: 'Circulante' },
        { value: 'Anestesiologo', text: 'Anestesiologo' },
        { value: 'Ayudante Anestesia', text: 'Ayudante Anestesia' },
        { value: 'Primer Ayudante', text: 'Primer Ayudante' },
        { value: 'Segundo Ayudante', text: 'Segundo Ayudante' },
        { value: 'Tercer Ayudante', text: 'Tercer Ayudante' },
        { value: 'Otros', text: 'Otros' },

      ],
      procedimientosService,
      personasService,
      selectedTipoIntegrante: null,
      dataProceso: null,
      idRegistroForm: null,
      selectedTipoDiagnostico: null,

      messageAlert: null,
      procedimientoSelected:null,

      preanestesico: {
        glascow:'',
        medicoResponsable:[],
        antecedentesPersonales: '',
        diagnosticosList: [],
        procedimientosList: [],
        tipoProcedimiento: '',
        diagnosticosAntePersonalesList: [],
        antecedentesAnestesicos: '',
        antecedentesQuirurgicos: '',
        antecedentesAlergicos: '',
        antecedentesTransfusiones: '',
        antecedentesHabitos: '',
        antecedentesFamiliares: '',
        constantesVitales: '',
        viaAerea: {
          aperturaBucal: '',
          distanciaTiromentoneana: '',
          mallampati: '',
          protrusionMandibular: '',
          perimetroCervical: '',
          movilidadCervical: '',
          historiaIntubacion: false,
          patologiaIntubacion: false,
          otros: ''
        },
        ekg: '',
        rxTorax: '',
        espirometria: '',
        otros: '',
        laboratorio: {
          hemograma: {
            hcto: '',
            hb: '',
            plaquetas: '',
            tp: '',
            ttp: '',
            inr: '',
            leucocitos: ''
          },
          tipificacion: {
            grupo: '',
            factor: ''
          },
          quimica: {
            glucosa: '',
            urea: '',
            creatinina: '',
            otros: ''
          },
          hepatico: {
            ast: '',
            alt: '',
            fa: '',
            ldh: '',
            bt: '',
            bd: '',
            bi: ''
          },
          ionograma: {
            na: '',
            k: '',
            ci: '',
            ca: '',
            mg: '',

          },
          gasometria: {
            ph: '',
            po2: '',
            pco2: '',
            hco3: '',
            eb: '',
            sat: '',
            lactato: '',

          },
          hormonas: {
            t4: '',
            tsh: '',


          },
          pruebaEmbarazo: false,

          orina: {
            ph: '',
            densidad: '',
            bacterias: '',
            leucocitos: '',
            piocitos: '',
            hematies: '',
            glucosa: '',

          },


        },
        escalas: {
          estadoAsa: '',
          riesgoCardiaco: '',
          riesgoPulmonar: '',
          riesgoTrombo: '',
          otros: '',
        },
        ultimaIngesta: {
          liquidosClaros: '',
          lecheMaterna: '',
          lecheFormula: '',
          solidos: ''
        },
        indicaciones: '',
        planAnestesico: '',
        observaciones: '',
        torax: '',
        corazon: '',
        pulmones: '',
        abdomen: '',
        extremidades: '',
        sistemaNervioso: '',
        equivalenteMetabolico: ''
      },

      searchDiagnostico: null,
      diagnosticosService,
      idProcActual: null,
      doctoresService,
      auxiliarService,
      periodo: null,
      notasEvolucion: null,
      farmacoterapia: null,
      doctor: null,
      auxiliar: null,
      dispositivo: null,
      profesional: null,
      fechaActual: null,
      horaActual: null,

      birthDateConfig: {
        allowInput: true,
        dateFormat: "Y-m-d", // Solo fecha
      },
      procedimiento: [],
      itemsTabla: [],
      fields: [


        {
          key: "diagnostico",
          label: "Diagnostico",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },
        {
          key: "acciones",
          label: "",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },
      ],

      fieldsIntegrantes: [

        {
          key: "tipo",
          label: "tipo",
          sortable: true,
          thClass: "text-center",
          tdClass: "small-column",
        },

        {
          key: "profesional",
          label: "Nombres Profesional",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },

        {
          key: "acciones",
          label: "",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },
      ],
       fieldsProcedimientos: [

        {
          key: "text",
          label: "nombres",
          sortable: true,
          thClass: "text-center",
          tdClass: "small-column",
        },

        {
          key: "acciones",
          label: "",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },
      ],

      fieldsMedicos: [

        {
          key: "nombres",
          label: "nombres",
          sortable: true,
          thClass: "text-center",
          tdClass: "small-column",
        },

        {
          key: "especialidad",
          label: "especialidad",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },


        {
          key: "identificacion",
          label: "identificacion",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },


        {
          key: "acciones",
          label: "",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },
      ],
    };
  },

  props: {
    procedimiento: {
      default: null,
      required: false
    },
    tokenProceso: {
      default: null,
      required: false
    },
    procedimientoObject: {
      default:null,
      required:false
    }
  },
  created() {

    this.setDate();
    ///this.loadData();

   
  },

  methods: {

    async searchAnestesiologo(){
      let result = await doctoresService.searchDoctoresByTermSelect()
      
      const codigosValidos = ["0000001538", "0000000004", "0000000570"];
      result = result.filter(e => codigosValidos.includes(e.codEsp));
     
      return result
    }, 

    agregarProfesional() {

      const listaActualIntegrantes = this.protocolo.integrantesList
      if (listaActualIntegrantes.length > 0) {
        listaActualIntegrantes.forEach(item => {
          console.log(this.selectedProfesional.value, item)
          if (this.selectedProfesional.value === item.profesional.idPersona) {

            this.$swal.fire({
              icon: 'info',
              text: 'Profesional ya registrado'
            })
            this.selectedProfesional = null
            this.selectedTipoIntegrante = null
            return
          }
        }
        )
      }
      this.protocolo.integrantesList.push(
        {
          tipo: this.selectedTipoIntegrante, profesional: {
            nombres: `${this.selectedProfesional.primerApellido} ${this.selectedProfesional.primerNombre}`,
            idPersona: this.selectedProfesional.value
          }
        }
      )
      this.selectedProfesional = null
      this.selectedTipoIntegrante = null
    },

    
    agregarProcedimiento() {

      const listProcedimientos = this.preanestesico.procedimientosList

      console.log("procedimineto elegido", this.procedimientoSelected)

      if (listProcedimientos && listProcedimientos.length > 0) {
        listProcedimientos.forEach(item => {
         
          if (this.procedimientoSelected.value === item.value) {

            this.$swal.fire({
              icon: 'warning',
              text: 'Procedimiento ya registrado, escoja otro'
            })
            this.procedimientoSelected = null
            
            return
          }
        }
        )
      }
      this.preanestesico.procedimientosList.push(
        this.procedimientoSelected
      )
      this.procedimientoSelected = null
      
    },


    async loadData() {
      this.protocolo = {
        urlImagen: null,
        proyectado: null,
        realizado: null,
        tipoAnestesia: null,
        fechaOperacion: null,
        horaInicio: null,
        horaTerminacion: null,
        dieresis: null,
        exposición: null,
        hallazgos: null,
        procedimientoQuirurgico: null,
        consentimiento: null,
        complicaciones: null,
        perdidaSanguineaTotal: null,
        sangradoAproximado: null,
        materialProtesico: null,
        dataMaterialProtesico: null,

        integrantesList: [],
        horaInicio: null,
        fechaOperacion: null,
        tipoAnestesia: "",

        diagnosticosList: [],

        medicosList: [],

      },

        this.dataProceso = null;
      this.idRegistroForm = null;

      //this.tokenProceso = this.$route.query.forms
      const tokenFormulario = this.$route.query.f017;

      const responseGet = await procedimientosFormulariosService.obtenerFormProcDataByToken(tokenFormulario);

      console.log("response get", responseGet)



      if (responseGet) {
        this.messageAlert = {
          variant: "success",
          text: "Se encontró información registrada, se procederá a actualizar"
        }

      } else {
        this.messageAlert = {
          variant: "warning",
          text: "No se encontró informacion registrada"
        }
        return;
      }

      let paciente = `${responseGet.procedimientoCita.consultamedica.cita.paciente.persona.identificacion}-${responseGet.procedimientoCita.consultamedica.cita.paciente.persona.primerApellido} ${responseGet.procedimientoCita.consultamedica.cita.paciente.persona.primerNombre} `

      const dataProceso = {
        paciente: paciente,
        codigo: responseGet.procedimientoCita.procedimiento.codigo,
        descripcion: responseGet.procedimientoCita.procedimiento.descripcion
      }

      try {
        const protocolo = JSON.parse(responseGet.dataJson)
        this.protocolo = protocolo
      } catch (error) { console.log("error", error) }


      this.dataProceso = dataProceso;
      this.idRegistroForm = responseGet.id;

    },

    setDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0"); // Meses van de 0 a 11
      const day = String(now.getDate()).padStart(2, "0");
      this.fechaActual = `${year}-${month}-${day}`;
      this.horaActual = now.getHours() + ":" + ("0" + now.getMinutes()).slice(-2);
    },


    eliminarRegistro(index) {
      this.preanestesico.diagnosticosList.splice(index, 1);


    },
     eliminarProcedimiento(index) {
      this.preanestesico.procedimientosList.splice(index, 1);


    },
    eliminarMedicoResponsable(index) {
      this.preanestesico.medicoResponsable.splice(index, 1);


    },
  


    eliminarMedico(index) {
      this.protocolo.tableMedicos.splice(index, 1);
    },


    agregarDiagnostico() {

      const dataTable = this.preanestesico.diagnosticosList;

      if (dataTable && dataTable.length > 5) {
        this.$swal.fire({
          icon: "info",
          text: "No puede agregar mas de 6 diagnosticos",
        });
        return;
      }



      this.preanestesico.diagnosticosList.push({
        diagnostico: this.searchDiagnostico.text,
        diagObject: this.searchDiagnostico,

      });

      this.searchDiagnostico = null;

    },



    agregarMedico() {
      const listMedico = this.preanestesico.medicoResponsable

      if(listMedico && listMedico.length > 0){
          

        this.$swal.fire({
          icon: "warning",
          text: `Ya existe un medico agregado`
        })
        return
      
      }

      if (!this.doctor) {

        this.$swal.fire({
          icon: "warning",
          text: `Elija el medico`
        })
        return
      }

      console.log(this.doctor)

      this.preanestesico.medicoResponsable.push({
        doctorObject: this.doctor,
        nombres: this.doctor.text,
        especialidad: this.doctor.especialidad,
        identificacion: this.doctor.idPersona.identificacion
      });
      this.doctor = null;
    },

    


    async onSavePreAnestesico() {

      const params = {
        nameForm: "018pre",
        dataJson: JSON.stringify(this.preanestesico),
        tokenProceso: this.tokenProceso,
        tokenFormulario:this.tokenFormulario,
        idRegistroForm: this.idRegistroForm
      };

      console.log("params que envio", params)

      const responseSave = await procedimientosFormulariosService.guardarData(params);

      if (!responseSave) {
        this.$swal({
          title: "Error",
          text: "No se guardo! Contacte al equipo de desarrollo",
          icon: "error",
          confirmButtonColor: "#089599",
        });

        return;
      }

      await this.$swal.fire({
        icon: "success",
        text: "Guardado correctamente",
      });
      this.$router.go(0);

    },
  },

  watch: {
    procedimientoObject: {
      deep:true,
      immediate:true,
      async handler(newValue){
        const procedimientoRecibido = {value:newValue.id, text:newValue.procedimiento, cod:newValue.codigo}
        this.preanestesico.procedimientosList.push(
        procedimientoRecibido
      )
      }
    },
   
  
    tokenProceso: {
      deep: true,
      immediate: true,
      async handler(newValue) {
        

        const formularioRegistrado = await procedimientosFormulariosService.getByTokenPrincipal(newValue, '018pre');

        const atencion = await procedimientosService.getDataAtencionByTokenProc(newValue)

        if (atencion) {
          if (atencion.diagnosticos) {
          this.preanestesico.diagnosticosList = atencion.diagnosticos
          }
           if (atencion.aPersonales) {
          this.preanestesico.antecedentesPersonales = atencion.aPersonales
          }
           if (atencion.aFamiliares) {
          this.preanestesico.antecedentesFamiliares = atencion.aFamiliares
          }
          if (atencion.exFisico) {
          this.preanestesico.torax = atencion.exFisico?.torax
          this.preanestesico.corazon = atencion.exFisico?.corazon
          this.preanestesico.abdomen = atencion.exFisico?.abdomen
          this.preanestesico.sistemaNervioso = atencion.exFisico?.neurologico
          this.preanestesico.pulmones = atencion.exFisico?.pulmones

          }

        }
        

        if (formularioRegistrado) {
          this.preanestesico = JSON.parse(formularioRegistrado[0].dataJson)
          this.tokenFormulario = formularioRegistrado[0].token

          return
        }


        const signos = await procedimientosService.getSignosByTokenProc(newValue)

        if (!formularioRegistrado && signos) {
          let tensionArterial = `${signos.tensionArterialSistolica}/${signos.tensionArterialDiastolica}`
          this.preanestesico.constantesVitales = {
            tensionArterial: tensionArterial,
            frecuenciaCardiaca: signos.pulso,
            frecuenciaRespiratoria: signos.freqRespiratoria,
            temperatura: signos.temperatura,
            saturacionOxigeno: signos.satOxigeno,
            peso: signos.peso,
            talla: signos.talla,
            imc: signos.imc,
            
          }
        }

        
      }
    },
  }

};
</script>

<style scoped>
.flatpickr-input {
  font-size: 0.85rem;
  padding: 0.25rem 0.5rem;
}

.parpadeo {
  font-weight: 200;
}
</style>
